<template>
  <div>
    <el-card>
      <!-- Header -->
      <div class="d-flex justify-content-between mb-3">
        <div class="d-flex">
          <div class="mr-2">
            <el-button 
              size="small"
              plain
              @click="voltar"
            >
              <i class="fas fa-arrow-left"></i>
              Voltar
            </el-button>
          </div>
  
          <div class="d-flex items-center">
              <el-tag type="info" class="mr-2">
                  <i class="fas fa-users fa-1x"></i>
              </el-tag>
              <h4 class="font-weight-semibold mb-0">Propostas Varejo</h4>
          </div>
        </div>
  
        <div class="d-flex align-items-center">
          <el-button 
            type="primary" 
            size="small" 
            @click="pedidosVarejo"
          >
            <i class="fas fa-shopping-cart"></i>
            Pedidos Varejo
          </el-button>
  
          <el-button 
            type="success" 
            size="small" 
            @click="addProposta"
            plain
          >
            <i class="fas fa-plus"></i> 
            Adicionar Proposta
          </el-button>
        </div>
      </div>
  
      <!-- Filtros -->
      <el-form label-position="top">
        <el-row class="mb-3 bg-red" type="flex" :gutter="12" align="bottom">
          <!-- Proposta -->
          <el-col :span="3">
            <label>Proposta</label>
            <el-input
              v-model="filtro.id" 
              size="small" 
              placeholder="Código da proposta"
              @keyup.enter.native.prevent="getPropostas()"
            />
          </el-col>
          
          <!-- Cliente -->
          <el-col :span="6">
            <label>Cliente</label>
            <el-input
              v-model="filtro.proposta" 
              size="small" 
              placeholder="Código ou nome do cliente"
              @keyup.enter.native.prevent="getPropostas()"
            />
          </el-col>
  
          <!-- Tipo -->
          <el-col :span="4">
              <label>Tipo</label>
              <el-select
                  v-model="filtro.tipo"
                  size="small"
                  placeholder="Tipo"
                  :disabled="isLoading"
                  filterable 
              >
                      <el-option
                          v-for="type in optionsTipo"
                          :key="type.value"
                          :label="type.text"
                          :value="type.value"
                      >
                  </el-option>
              </el-select>
          </el-col>

          <!-- Classificacao bonificacao -->
          <el-col :span="4">
              <label>Classificação Bonificação</label>
              <el-select
                  v-model="filtro.classificacao_bonificacao"
                  size="small"
                  placeholder="Classificação"
                  :disabled="isLoading"
              >
                  <el-option
                      v-for="classificacao in optionsClassificacaoBonificacao"
                      :key="classificacao.value"
                      :label="classificacao.text"
                      :value="classificacao.value"
                  >
                  </el-option>
              </el-select>
          </el-col>

          <!-- Acoes -->
          <el-col :span="4">
              <!-- <el-tooltip class="item" effect="light" content="Limpar filtros" placement="bottom-end">
                  <el-button
                      size="small" 
                      circle 
                      plain
                      :disabled="loading || shouldBeClear"
                      @click="clean()"
                  >
                      <i class="el-icon-delete"></i>
                  </el-button>
              </el-tooltip> -->
              <!-- <el-button 
                  size="small" 
                  :disabled="loading" 
                  @click="fetch()"
              >
                  <i class="fas fa-search"></i>
                  Buscar
              </el-button> -->
  
              <el-button 
                  size="small" 
                  :disabled="isLoading" 
                  @click="getPropostas()"
              >
                  <i class="fas fa-search"></i>
                  Buscar
              </el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-row>
        <div class="d-flex align-items-center justify-content-between">
            <el-radio-group 
              v-model="filtro.status"
              size="mini"
              :disabled="isLoading"
              @change="getPropostas()"
            >
                <el-radio-button 
                    v-for="(stat) in options"
                    :key="stat.text"
                    :label="stat.value"
                >
                    <div class="d-flex align-items-center">
                        <el-tag 
                            :type="stat.text == 'Todos' 
                                ? '' 
                                : (stat.text == 'Aprovado' 
                                    ? 'success' 
                                    : (stat.text == 'Aberto' 
                                        ? 'warning' 
                                        : 'danger'
                                        )
                                    )"
                            size="mini" 
                            class="mr-1"
                        >
                            {{  filtro.status == stat.value ? filtro.total : 0  }}
                        </el-tag>
                        <span class="ml-1">{{ stat.text }}</span>
                    </div>
                </el-radio-button>
            </el-radio-group>
  
            <!-- <el-dropdown size="mini" split-button plain @command="handleSetOrder">
                <strong>Ordernar</strong>: {{ filtro.orderBy == 'latest' ? 'Recentes' : 'Antigos' }}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="latest">
                        <div class="d-flex align-items-center">
                            <i class="el-icon-top mr-2"></i>
                            Mais Recentes
                        </div>
                    </el-dropdown-item>
                    <el-dropdown-item command="oldest">
                        <div class="d-flex align-items-center">
                            <i class="el-icon-bottom mr-2"></i>
                            Mais Antigos
                        </div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
        </div>

        <!-- Tabela -->
        <el-row>
          <div v-if="isLoading" class="border rounded p-3 d-flex align-items-center">
              <i class="el-icon-loading mr-2"></i>
              Carregando propostas...
          </div>

          <!-- content -->
          <div v-else-if="!isLoading && propostas.length > 0">                    
              <el-table
                class="rounded"
                empty-text="Nenhuma proposta encontrada." 
                :data="propostas" 
                align="center" 
                border
                row-key="id"
                size="mini"
              >   
                <!-- ID -->
                <el-table-column 
                    label="ID" 
                    width="90"
                    prop="id" 
                    align="left"
                >
                    <div slot-scope="scope">{{ scope.row.id }}</div>
                </el-table-column>

                <!-- Codigo -->
                <el-table-column label="#Código" width="110" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.codigo }}</span>
                    </template>
                </el-table-column>

                <!-- Cliente -->
                <el-table-column min-width="320" label="Cliente" align="left">
                    <template slot-scope="scope">
                        <span>{{ scope.row.nome }}</span>
                    </template>
                </el-table-column>

                <!-- Tipo proposta -->
                <el-table-column label="Tipo Proposta" width="120" align="left">
                    <template slot-scope="scope">
                      <el-tag
                        :type="scope.row.tipo_proposta == 'VENDA' 
                                ? 'success' 
                                : (scope.row.tipo_proposta == 'AMOSTRA' 
                                  ? 'warning' 
                                  : (scope.row.tipo_proposta == 'BONIFICACAO' ? '': 'info' )
                                )"
                        size="small"
                      >{{ scope.row.tipo_proposta }}</el-tag>
                      <div v-if="scope.row.classificacao_bonificacao" style="font-size: 11px">
                        {{ textoClassificacao(scope.row.classificacao_bonificacao) }}
                      </div>
                    </template>
                </el-table-column>

                <!-- Status -->
                <el-table-column label="Situação/Status" width="130" align="left">
                    <template slot-scope="scope">
                        <el-tag 
                            v-if="scope.row.status"
                            type="info" 
                            size="small"
                            :type="scope.row.status === 'ABERTO' 
                                ? '' 
                                : (scope.row.status == 'APROVADO' ? 'success' : 'danger')"
                        >
                            {{ scope.row.status }}
                        </el-tag>
                    </template>
                </el-table-column>

                <!-- Criado em -->
                <el-table-column label="Criado em" width="130" align="center">
                    <template slot-scope="scope">
                        <div class="d-flex align-items-center justify-content-center">
                            <i class="el-icon-time"></i>
                            <span class="ml-1">{{ formatDate(scope.row.created_at, 'DD/MM/YYYY') }}</span>
                        </div>
                    </template>
                </el-table-column>

                <!-- Valor bruto -->
                <el-table-column
                  prop="valor_bruto"
                  label="Valor Bruto"
                  width="110"
                >
                  <template slot-scope="scope">
                    {{ scope.row.valor_bruto ? 'R$ ' + parseFloat(scope.row.valor_bruto).toFixed(2).toString().replace('.', ',') : '-' }}
                  </template>
                </el-table-column>

                <!-- Desconto -->
                <el-table-column
                  prop="valor_desconto"
                  label="Desconto"
                  width="110"
                >
                  <template slot-scope="scope">
                    {{ scope.row.valor_desconto ? 'R$ ' + parseFloat(scope.row.valor_desconto).toFixed(2).toString().replace('.', ',') : '-' }}
                  </template>
                </el-table-column>

                <!-- Total -->
                <el-table-column
                  prop="valor"
                  label="Total"
                  width="110"
                >
                  <template slot-scope="scope">
                    {{ scope.row.valor ? 'R$ ' + parseFloat(scope.row.valor).toFixed(2).toString().replace('.', ',') : '-' }}
                  </template>
                </el-table-column>

               <!-- Status -->
                <el-table-column label="Status de Aprovação" width="170" align="center">
                    <template slot-scope="scope">
                        <div class="d-flex align-items-center justify-content-center">
                          <div class="text-center" v-if="
                            (scope.row.tipo_proposta == 'BONIFICACAO' ||
                              scope.row.tipo_proposta == 'REQUISICAO' ||
                              scope.row.tipo_proposta == 'AMOSTRA_DISTRIBUIDOR' ||
                              scope.row.tipo_proposta == 'AMOSTRA') &&
                            scope.row.aprovado
                          ">
                            <span>APROVADO POR: </span>
                            <p class="m-0" style="font-size: 12px">
                              <b>{{ scope.row.aprovador.name }}</b>
                            </p>
                          </div>
                          <div class="text-center" v-else-if="
                            (scope.row.tipo_proposta == 'BONIFICACAO' ||
                              scope.row.tipo_proposta == 'AMOSTRA') &&
                            !scope.row.aprovado
                          ">
                            <span>AGUARDANDO</span>
                          </div>
                          <div class="text-center" v-else>
                            <span>-</span>
                          </div>
                        </div>
                    </template>
                </el-table-column>
                  
                <!-- Acoes -->
                <el-table-column 
                  prop="acoes"
                  width="160"
                  fixed="right"
                  align="right"
                >
                  <div slot="header" style="width: 100%;">
                    <i class="el-icon-menu" />
                  </div>

                  <template slot-scope="scope">
                    <div class="d-flex justify-content-between">
                      <!-- Editar ou visualizar -->
                      <el-tooltip 
                          class="item" 
                          effect="light" 
                          :content="scope.row.status != 'APROVADO' ? 'Editar proposta' : 'Visualizar proposta'" 
                          placement="bottom-end"
                      >
                          <el-button
                              size="mini" 
                              :type="scope.row.status != 'APROVADO' ? 'warning' : 'primary'" 
                              plain 
                              circle
                              :disabled="isLoading"
                              @click.native.prevent="editar(scope.row.id)"
                          >
                              <i v-if="scope.row.status != 'APROVADO'" class="fa fa-edit"></i>
                              <i v-else class="el-icon-right"></i>
                          </el-button>
                      </el-tooltip>

                      <!-- Imprimir -->
                      <el-tooltip 
                        class="item" 
                        effect="light" 
                        content="Imprimir proposta" 
                        placement="bottom-end"
                      >
                        <el-button
                          size="mini"  
                          plain 
                          circle
                          :disabled="isLoading"
                          @click.native.prevent="imprimir(scope.row.id)"
                        >
                          <i class="fa fa-print"></i>
                        </el-button>
                      </el-tooltip>

                      <!-- Copiar -->
                      <el-tooltip 
                        v-if="scope.row.status !== 'CANCELADO'"
                        class="item" 
                        effect="light" 
                        content="Copiar proposta" 
                        placement="bottom-end"
                      >
                        <el-button
                          size="mini"
                          type="success"  
                          plain 
                          circle
                          :disabled="isLoading"
                          @click.native.prevent="copiar(scope.row.id)"
                        >
                          <i class="fa fa-copy"></i>
                        </el-button>
                      </el-tooltip>

                      <!-- Espelho do pedido -->
                      <el-tooltip 
                        v-if="scope.row.pedido"
                        class="item" 
                        effect="light" 
                        content="Espelho do pedido" 
                        placement="bottom-end"
                      >
                        <el-button
                          size="mini"
                          type="info"  
                          plain 
                          circle
                          :disabled="isLoading"
                          @click.native.prevent="imprimirPedido(scope.row.pedido.id)"
                        >
                          <i class="fa fa-file-alt"></i>
                        </el-button>
                      </el-tooltip>

                      <!-- Excluir -->
                      <el-tooltip 
                        v-if="scope.row.status != 'APROVADO'"
                        class="item" 
                        effect="light" 
                        content="Excluir proposta" 
                        placement="bottom-end"
                      >
                        <el-button
                          size="mini"
                          type="danger"  
                          plain 
                          circle
                          :disabled="isLoading"
                          @click.native.prevent="destroy(scope.row.id)"
                        >
                          <i class="fas fa-trash"></i>
                        </el-button>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
          </div>

          <el-empty v-else description="Nenhum distribuidor disponível"></el-empty>
        </el-row>
  
        <!-- Paginacao -->
        <el-row class="mt-3">
            <el-col>
                <el-pagination
                  background
                  :current-page.sync="filtro.currentPage"
                  :page-sizes="[15, 50, 75, 100]"
                  :page-size="filtro.perPage"
                  layout="total, sizes, prev, pager, next"
                  :total="filtro.total"
                  @current-change="getPropostas"
                  @size-change="handleSizeChange"
                >
                </el-pagination>
            </el-col>
        </el-row>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import { 
    Card,
    Tag, 
    Button,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    RadioGroup,
    RadioButton,
    Pagination,
    Empty,
    Tooltip
  } from 'element-ui';

  import { formatDate } from '@/util/formatters.js';

export default {
  name: "proposta-venda-direta",
  data() {
    return {
      filtro: {
        id: "",
        status: null,
        proposta: "",
        tipo: null,
        classificacao_bonificacao: null,
        perPage: 15,
        currentPage: 1,
        total: 0,
      },
      propostas: [],
      cliente: null,
      isLoading: false,
      optionsTipo: [
        { value: null, text: "TODOS" },
        { value: 'VENDA', text: "VENDA" },
        { value: 'AMOSTRA', text: "AMOSTRA" },
        { value: 'BONIFICACAO', text: "BONIFICAÇÃO" },
        { value: 'REQUISICAO', text: "REQUISIÇÃO" }
      ],
      optionsClassificacaoBonificacao: [
        { value: null, text: "TODAS" },
        { value: 'PLANO_INTRODUCAO_REDES', text: "Plano de Introdução Redes" },
        { value: 'OUTROS', text: "Outros" }
      ],
      options: [
        {value: null,text: "Todos",default:true},
        {value: "ABERTO",text: "Aberto"},
        {value: "APROVADO",text: "Aprovado",},
        { value: 'CANCELADO', text: "Cancelado" },
        
      ],
      header: [
        {
          key: "id",
          label: "Número",
          class: "text-center",
          tdClass: "align-middle",
        },
        {
          key: "codigo",
          label: "Código",
          class: "text-center",
          tdClass: "align-middle",
        },
        {
          key: "nome",
          label: "Cliente",
          tdClass: "align-middle",
        },
        {
          key: "tipo_proposta",
          label: "Tipo Proposta",
          formatter: (value) => {
            return value == 'AMOSTRA_DISTRIBUIDOR' ? 'AMOSTRA DISTRIBUIDOR' : value
          },
          tdClass: "align-middle",
        },
        {
          key: "status",
          label: "Situação",
          tdClass: "align-middle",
        },
        {
          key: "created_at",
          label: "Data",
          formatter: (value) => {
            return moment(value).format("DD/MM/YYYY");
          },
          tdClass: "align-middle",
        },
        {
          key: "valor_bruto",
          label: "Valor Bruto",
          tdClass: "align-middle",
        },
        {
          key: "valor_desconto",
          label: "Desconto",
          formatter: (value) => {
            return 'R$ ' + parseFloat(value).toFixed(2).toString().replace('.', ',');
          },
          tdClass: "align-middle",
        },
        {
          key: "valor",
          label: "Total",
          formatter: (value) => {
            return 'R$ ' + parseFloat(value).toFixed(2).toString().replace('.', ',');
          },
          tdClass: "align-middle",
        },
        {
          key: "status_aprovacao",
          label: "Status de Aprovação",
          tdClass: "align-middle",
        },
        {
          key: "actions",
          label: "#",
          tdClass: "align-middle",
        },
      ],
    };
  },
  methods: {
    imprimirPedido(id) {
      window.open("/venda-direta/pedidos/" + id + "/imprimir", "_blank");
    },
    copiar(id) {
      const vm = this;
      vm.$swal
        .fire({
          title: "Atenção",
          text: "Deseja realmente copiar a proposta " + id + " ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, Copiar!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            $(".loading").show();
            axios
              .post("/venda-direta/proposta/copiar/" + id)
              .then((response) => {
                vm.$swal(response.data.msg, "", "success");
                this.getPropostas();
              })
              .catch((error) => {
                console.log(error);
                vm.$swal("Erro ao copiar proposta", "", "error");
              })
              .finally(() => {
                $(".loading").hide();
              });
          }
        });
    },
    voltar() {
      window.location.href = "/venda-direta/";
    },

    pedidosVarejo() {
      window.location.href = "/venda-direta/pedidos/";
    },
    addProposta() {
      window.location.href = "/venda-direta/proposta/";
    },
    editar(id) {
      window.location.href = "/venda-direta/proposta/" + id + "/edit";
    },
    imprimir(id) {
      window.open("/venda-direta/proposta/" + id + "/imprimir", "_blank");
    },
    destroy(id) {
      const vm = this;
      vm.$swal
        .fire({
          title: "Realmente deseja deletar esta proposta ?",
          text: "Esta ação não poderá ser revertida!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim Deletar!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            $(".loading").show();
            axios
              .delete("/venda-direta/proposta/" + id)
              .then((response) => {
                vm.$swal(response.data.msg, "", "success");
                vm.getPropostas();
                $(".loading").hide();
              })
              .catch((error) => {
                console.log(error, "erro ao deletar proposta");
                var e = error.response.data;
                $(".loading").hide();
                vm.$swal(
                  "Desculpe",
                  "\n" +
                  (e.msg ? e.msg : "Houve um erro ao deletar a proposta."),
                  "error"
                );
              });
          }
        });
    },
    getPropostas() {
      const vm = this;
      vm.propostas = [];
      vm.isLoading = true;
      let data = {
        perPage: this.filtro.perPage,
        currentPage: this.filtro.currentPage,
        status: vm.filtro.status,
        proposta: vm.filtro.proposta,
        tipo: vm.filtro.tipo,
        classificacao_bonificacao: vm.filtro.classificacao_bonificacao,
        id : vm.filtro.id
      };
      axios
        .get("/venda-direta/propostas/listar", {
          params: data,
        })
        .then((response) => {
          vm.propostas = response.data.data;
          this.filtro.total = response.data.total;
          this.filtro.currentPage = response.data.current_page;
          vm.propostas.forEach((el) => {
            el.codigo = el.prospecto
              ? el.prospecto.distribuidor
                ? el.prospecto.distribuidor.codigo
                : ""
              : el.distribuidor.codigo;
            el.nome = el.prospecto
              ? el.prospecto.distribuidor
                ? el.prospecto.distribuidor.nome
                : el.prospecto.prospecto_empresa.pessoa_juridica
                  ? el.prospecto.prospecto_empresa.pessoa_juridica.razao_social
                  : el.prospecto.prospecto_empresa.pessoa_fisica.nome
              : el.distribuidor.nome;
          });
          // console.log(vm.propostas)
          vm.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          vm.isLoading = false;
        });
    },
    textoClassificacao(value) {
      const classificacao = this.optionsClassificacaoBonificacao.find((el) => el.value == value);
      return classificacao ? classificacao.text : value;
    },
    // Pagination
    handleSizeChange(val) {
        this.filtro.perPage = val
        this.getPropostas();
    },
    formatDate
  },
  computed: {
    showPropostas() {
      return this.propostas;
    },
  },
  mounted() {
    this.getPropostas();
  },
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Pagination.name]: Pagination,
    [Empty.name]: Empty,
    [Tooltip.name]: Tooltip
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/varejo/propostas/lista.vue